export const resource = {
  test: "I am a site specific resource",
}